angular.module('impactx.ruleset').controller('RuleAccountingCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'TranslationService',
    'BackService',
    'ToolbarService',
    RuleAccountingCtrl
]);

function RuleAccountingCtrl($scope, dataGen, $routeParams, ToastService, TranslationService, BackService, ToolbarService) {
    var self = this;
    $scope.controlTypeArray = [{field: "csType", value: 0}];

    dataGen.getData($scope, {
        id: $routeParams.id,
        ruleSetId: $routeParams.ruleSetId,
        ruleType: $routeParams.ruleType
    }, "/ruleset/viewaccountingrule").then(function () {
        $scope.controlTypeArray[0].value = impactX.isDefined($scope.data.control, 'controlType.selected.id');
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.delete = TranslationService.get('delete');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');

        defineButtons();
    });

    self.save = function () {
        return dataGen.postAsForm($scope, {formData: $scope.data}, "/ruleset/saveaccountingrule").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.changeControlType = function (newValue, oldValue) {
        $scope.controlTypeArray[0].value = $scope.data.control.controlType.selected.id;
        if (oldValue && (!newValue || oldValue.id !== newValue.id)) {
            $scope.data.control.control.selected = {};
        }
    };

    self.delete = function () {
        return dataGen.postAsForm($scope, {id: $scope.data.id}, "/ruleset/deleterule").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && $scope.data.id > 0;
    }
}